import { Button, Flex, Modal, Typography } from '@iheartjane/reefer';

import type { ConditionSection, ConditionSelection } from './conditions.types';
import { ConditionSummary } from './conditionSummary';

export interface ConfirmDeleteConditionsProps {
  appId?: string;

  /** The sections the group was built from, used to label its selections */
  conditions: ConditionSection[];

  /** The group's position as titled in the editor, 1-based */
  groupNumber: number;

  onCancel(): void;

  onConfirm(): void;

  /** The selections belonging to the group being deleted */
  selection: ConditionSelection;
}

/** Confirms deleting a condition group, summarizing the selections it would take with it */
export const ConfirmDeleteConditions = ({
  appId = 'parent',
  conditions,
  groupNumber,
  onCancel,
  onConfirm,
  selection,
}: ConfirmDeleteConditionsProps) => {
  return (
    <Modal appId={appId} onRequestClose={onCancel} open variant="dialogue">
      <Modal.Content>
        <Flex flexDirection="column" width={432}>
          <Typography variant="h2-semibold" mb={32}>
            Delete Condition Group {groupNumber}?
          </Typography>
          <ConditionSummary conditions={conditions} selection={selection} />
          <Typography variant="body-semibold" mt={16} mb={8}>
            This action cannot be undone.
          </Typography>
          <Flex mt={24} width="100%">
            <Button
              full
              label="Cancel"
              mr={16}
              onClick={onCancel}
              variant="tertiary"
            />
            <Button
              full
              label="Delete"
              onClick={onConfirm}
              variant="destructive"
            />
          </Flex>
        </Flex>
      </Modal.Content>
    </Modal>
  );
};
